/**
 * HOC to wrap a component with a data attribute for easier debugging in development
 * @param {React.ComponentType} Component - Component to be wrapped
 * @param {string} label - Label to assign to the data attribute
 * @returns {React.FC} - Wrapped component
 */

export const withComponentLabel = (Component, label) => (props) => (
  process.env.NODE_ENV === 'development' ? (
    <div data-component={label} style={{ display: 'contents' }}>
      <Component {...props} />
    </div>
  ) : (
    <Component {...props} />
  )
);